import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_fem_sales_tax_exclusion_i3~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fasting_fem_sales_tax_exclusion_i3_b'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_fem_sales_tax_exclusion_i3~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_fasting_fem_sales_tax_exclusion_i3_c'),
			},
		},
	},
]

export default config
